<ra-ui-breadcrumb
  [id]="id"
  [items]="items"
  [title]="title"
  [config]="resolvedConfig"
  [isReadOnly]="isReadOnly"
  (onClick)="itemClicked.emit($event)"
>
</ra-ui-breadcrumb>
